<div class="form-group row single-select-search-input mb-{{ formMargin }}">
  <app-custom-form-label
    *ngIf="label?.length > 0"
    [label]="label"
    [required]="required"
    [showInfoAsTooltip]="showInfoAsTooltip"
    [toolTip]="tooltipText"
    class="col-md-{{ labelSize }} col-xs-12 weight-600 {{
      showInfoAsTooltip ? 'mt-2' : 'mt-0'
    }} {{ +labelSize === 12 && +inputSize === 12 ? 'mb-1' : 'mb-0' }}"
  ></app-custom-form-label>

  <div
    class="col-md-{{ 12 - inputSize - labelSize }}"
    *ngIf="12 - inputSize - labelSize > 0"
  ></div>

  <div
    class="col-md-{{ inputSize }}"
    [nbTooltip]="disabledTooltip"
    [nbTooltipDisabled]="!disabledTooltip?.length"
  >
    <div
      [ngClass]="disabled ? 'disabled-input' : ''"
      class="d-flex justify-content-between cursor-pointer w-100 input-parent rounded select-popover-trigger custom-select-button"
      #singleSelectSearchDropdownPopover="nbPopover"
      [nbPopover]="optionsPopover"
      nbPopoverTrigger="click"
      nbPopoverAdjustment="vertical"
      nbPopoverPlacement="bottom"
      [nbSpinner]="loading"
      nbPopoverClass="single-select-options-popover"
      (nbPopoverShowStateChange)="showStateChange($event)"
    >
      <span
        class="placeholder-text ml-3 mr-2"
        *ngIf="!customFormControl?.value"
      >
        {{ selectInputPlaceholder }}
      </span>
      <!-- <span class="selected-option-text ml-3 mr-2" *ngIf="selectedOption">
        {{ selectedOption.label }}
      </span> -->
      <input
        nbInput
        class="select-input"
        [formControl]="customFormControl"
        readonly
        *ngIf="customFormControl?.value"
      />

      <div class="d-flex align-items-center justify-content-end mr-1">
        <nb-icon
          *ngIf="customFormControl?.value && showClearOption"
          icon="close-outline"
          class="cursor-pointer mr-2"
          style="height: 80%"
          (click)="clearSelectedOption($event)"
        ></nb-icon>
        <nb-icon
          [icon]="
            openOptionsPopover ? 'chevron-up-outline' : 'chevron-down-outline'
          "
          class="cursor-pointer"
        ></nb-icon>
      </div>
    </div>
  </div>
</div>

<ng-template #optionsPopover>
  <div class="p-2">
    <input
      class="w-100"
      style="max-width: 100% !important"
      id="{{ searchInputId }}"
      [formControl]="searchString"
      nbInput
      type="search"
      fieldSize="small"
      (input)="getFilteredOptions()"
      placeholder="{{ searchInputPlaceholder }}"
      autocomplete="off"
    />
  </div>
  <div *ngIf="!categorySelection" style="max-height: 30vh; overflow-y: auto">
    <ng-container *ngIf="filteredOptions?.length">
      <ng-container *ngFor="let option of filteredOptions">
        <div
          class="px-3 py-2 d-flex justify-content-between align-items-center cursor-pointer option"
          [ngClass]="{ selected: customFormControl?.value === option?.value }"
          (click)="selectOption(option)"
        >
          <label class="weight-600 cursor-pointer m-0">{{
            option?.label
          }}</label>
          <nb-icon
            *ngIf="showSuffixIcon"
            [icon]="optionsIcon"
            pack="fci"
            (click)="optionIconClicked($event, option)"
          ></nb-icon>
        </div>
      </ng-container>
      <div
        class="d-flex align-items-center justify-content-center w-100 py-2 create-new-option"
        nbPopoverTrigger="hover"
        (click)="onCreateNewOption($event)"
        *ngIf="createNewOptionLabel?.length"
      >
        <span class="weight-600">{{ createNewOptionLabel }}</span>
        <nb-icon icon="plus-circle-outline" pack="fci" class="ml-2"></nb-icon>
      </div>
    </ng-container>
    <div class="my-2 ml-3" *ngIf="!filteredOptions?.length">
      No {{ label | lowercase }} present
    </div>
  </div>

  <div *ngIf="categorySelection">
    <div
      style="max-height: 30vh; overflow-y: auto"
      *ngIf="(filteredGroupedOptions | keyvalue)?.length; else noOptions"
    >
      <nb-option-group
        *ngFor="let option of filteredGroupedOptions | keyvalue"
        title="{{ option?.key }}"
        class="pl-3 py-2 weight-600"
      >
        <nb-option
          *ngFor="let optionValue of option.value"
          value="{{ optionValue?.label }}"
          class="d-flex align-item-center pl-3 py-2"
          style="cursor: pointer"
          (click)="selectGroupedOption(optionValue, option?.key)"
          >{{ optionValue?.label }}
        </nb-option>
      </nb-option-group>
    </div>
  </div>
</ng-template>

<ng-template #noOptions>
  <nb-option
    style="height: 10vh"
    class="d-flex align-items-center justify-content-center"
    >No resources found to show.
  </nb-option>
</ng-template>
